const tables = [
  {
    name: "Number",
  },
  {
    name: "Customer",
  },
  {
    name: "Date",
  },
  {
    name: "Due",
  },
  {
    name: "Total",
  },
  {
    name: "Created",
  },
  {
    name: "Action",
  },
];

export default tables;
